import {createSlice, createAsyncThunk, PayloadAction} from "@reduxjs/toolkit";
import {JoinCallURL, SignatureURL} from "../config/api.ts";
import axios from "axios";
import { getUserFriendlyError } from "@common/errorHandler.ts";


interface CallState {
    ticketId: string;
    hasVideo: boolean;
    startCall: boolean;
    token?: string;
    joinLoading: boolean;
    joinError?: string;
}

const initialState: CallState = {
    ticketId: '',
    hasVideo: false,
    startCall: false,
    token: undefined,
    joinLoading: false,
    joinError: undefined
};


export const joinCall = createAsyncThunk(
    'call/joinCall',
    async (payload: { ticketId: string; topic: string; hasVideo: boolean; action: string }, {rejectWithValue}) => {
        try {
            const response = await axios.post(
                JoinCallURL,
                payload
            );
            return response.data.data;
        } catch (error: any) {
            return rejectWithValue(getUserFriendlyError(error));
        }
    }
);
export const generateCallToken = createAsyncThunk<{ token: string }, void>(
    "call/generateToken",
    async (_, {getState}: any) => {
        const {ticketId} = (await getState()).call
        const zoomSignaturePayload = {
            topic: ticketId.toString(),
            roleType: 1,
            sessionKey: ticketId.toString(),
        };
        const req = await axios.post(SignatureURL, zoomSignaturePayload);
        return {token: req.data.data}
    }
);

const callSlice = createSlice({
    name: "call",
    initialState,
    reducers: {
        setCall: (state, action) => {
            state.ticketId = action.payload.ticketId
            state.hasVideo = action.payload.hasVideo
            state.token = undefined
        },
        startCall: (state) => {
            state.startCall = true
        },
        initiateCall: (state, action) => {
            state.ticketId = action.payload.ticketId
            state.hasVideo = action.payload.hasVideo
            state.token = undefined
            state.startCall = action.payload.startCall
        },
        endCall: () => {
            return initialState

        },
    },
    extraReducers: (builder) => {
        builder.addCase(
            generateCallToken.fulfilled,
            (state, action: PayloadAction<{ token: string }>) => {
                state.token = action.payload.token;
            }
        );
        builder.addCase(joinCall.pending, (state) => {
            state.joinLoading = true
            state.joinError = undefined
        });
        builder.addCase(joinCall.fulfilled, (state) => {
            state.joinLoading = false
            state.joinError = undefined
        });
        builder.addCase(joinCall.rejected, (state) => {
            state.joinLoading = false
            state.joinError = 'Error'
        });
    },
});

export const {setCall, startCall, endCall, initiateCall} = callSlice.actions
export default callSlice.reducer;
